module.exports = __webpack_public_path__ + "static/media/briefcase.1a0a84b4.svg";